var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"ml-3 mr-3 my-2",attrs:{"to":"/"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-home")]),_vm._v(" Return Home ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }